import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import AccountService from 'cio/services/account';
import BillingService from 'cio/services/billing';
import AnalyticsService from 'cio/services/analytics';
import AlertsService from 'cio/services/alerts';
import RouterService from '@ember/routing/router-service';
import MomentService from 'cio/services/-moment';
import { STRIPE_ERROR_CODES } from 'cio/utils/errors/formatters/stripe';
import { StartupType } from 'cio/utils/billing/startup';
import { task } from 'ember-concurrency';

export default class YourPlanController extends Controller {
  @service billing!: BillingService;
  @service account!: AccountService;
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service router!: RouterService;
  @service moment!: MomentService;

  @tracked showCancelAccountModal = false;

  get isSpecificStripeError() {
    return this.billing.subscription?.stripeCustomer?.lastPaymentError ?? '' in STRIPE_ERROR_CODES;
  }

  get shouldShowBillingAlert() {
    let isLumpSumCustomerWithOverageInvoiceOverdue =
      this.billing.billingInfo?.lumpSum === true && this.billing.subscription?.hasFailedOverageCharge === true;
    return (
      this.billing.billingInfo?.overdue === true &&
      (Boolean(this.isSpecificStripeError) || isLumpSumCustomerWithOverageInvoiceOverdue)
    );
  }

  get isStartupAccount() {
    return (
      this.billing.billingInfo?.startupProgram === StartupType.Plus ||
      this.billing.billingInfo?.startupProgram === StartupType.Basic ||
      this.billing.billingInfo?.startupProgram === StartupType.Essentials
    );
  }

  @action
  navigateToPaymentMethods() {
    this.router.transitionTo('settings.billing.payment-methods');
  }

  @action
  toggleShowCancelAccountModal() {
    this.showCancelAccountModal = true;
    this.analytics.track('account', 'cancellation_started');
  }

  cancelAccount = task({ drop: true }, async (feedback: string) => {
    this.billing.cancelAccount.perform(feedback);
    this.showCancelAccountModal = false;
  });
}
declare module '@ember/controller' {
  interface Registry {
    'billing.your-plan': YourPlanController;
  }
}
